import React from 'react';
import Moment from 'react-moment';
import {connect} from "react-redux";
import TextTranslate from '../../../Components/TextTranslate/TextTranslate';

const RegistrationCard = ({invitation, currentLanguage}) => {

    if (!invitation) {
        return <></>;
    }

    return (
        <div className="card overview bg-white">
            <div className="card-body">
                <div className="card-title"><TextTranslate name="reg-your-registration" fallback="Your Registration"/></div>
                <div className="row">
                    <div className="col-6 text-primary"><TextTranslate name="reg-status" fallback="Status"/></div>
                    <TextTranslate className="col-6 p-0" name={`reg-status-${invitation.registration_status}`}/>
                </div>
                <div className="row">
                    <div className="col-6 text-primary"><TextTranslate name="reg-number-invitees" fallback="Number Of Invitees"/></div>
                    <div className="col-6 p-0">{invitation.guest_allowance}</div>
                </div>
                <div className="row">
                    <div className="col-6 text-primary"><TextTranslate name="reg-deadline" fallback="Deadline"/></div>
                    <div className="col-6 p-0"><Moment locale={currentLanguage.code} format="DD/MM/YYYY" date={invitation.event.reg_deadline} /></div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
    invitation: state.invitation.data,
});

export default connect(mapStateToProps)(RegistrationCard);

